module.exports = __webpack_public_path__ + "static/media/studio-lounge.3197a4d7.jpg";